import React, { Component, Fragment } from 'react';

class ModalConfirm extends Component {

    state = {
        load: false,
    }

    componentDidMount() {

    }

    confirmModal = () => {
        if (this.props.function) {
            this.props.function();
        }
    }

    render() {
        return (
            <Fragment>
                <div id="modal-alert" data-toggle="modal" data-target=".modal-alert"></div>
                <div className="modal fade modal-alert" data-backdrop="static" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="myLargeModalLabel">
                                    {this.props.title}
                                </h5>
                                <button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className={this.props.classText} dangerouslySetInnerHTML={{__html: this.props.msg}}>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button id="close-modal-confirm" type="button" className="col-md-2 btn btn-secondary btn-rounded waves-effect" data-dismiss="modal" onClick={this.confirmModal}>Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
        )
    }

}

export default ModalConfirm;